import Step from '../_Step'
import {withStyles} from '@material-ui/core/styles'
import {setup, createField, collectValues, validate, validateSilent} from './quickfield-base-methods'

class Details extends Step
	constructor: ()->
		super()
		@fields = []
	
	render: ()->
		super([], @props.classes)
	
	onNextStep: ()->
		fbq?('trackCustom', 'FilledDetails')
		if name = @props.formState.values?.name
			app.logrocket?.identify?(name)
	
	componentDidMount: ()-> @setup()
	setup: setup
	createField: createField
	collectValues: collectValues
	validate: validate
	validateSilent: validateSilent


styles =
	fields:
		maxWidth: '500px'

export default withStyles(styles)(Details)